import React, { ReactNode } from 'react'

import { AbilityProvider as RAAbilityProvider, DataProviderProvider, SessionProvider } from '@/shared/contexts'
import { useSession } from '@/shared/hooks'
import { defineAbilityFor } from '@/shared/lib/ability'

export const AbilityProvider = ({ children }) => {
  const { data: session } = useSession()
  const ability = defineAbilityFor(session?.user)

  return <RAAbilityProvider ability={ability}>{children}</RAAbilityProvider>
}
